import { ProjektFinancovanieInyZdroj } from './projekt-financovanie-iny-zdroj';
import { ProjektFinancovanieStatnaPomoc } from './projekt-financovanie-statna-pomoc';

/**
 * 
 * @export
 * @interface ProjektFinancovanie
 */
export interface ProjektFinancovanie {
    /**
     * 
     * @type {Array<ProjektFinancovanieInyZdroj>}
     * @memberof ProjektFinancovanie
     */
    'ineZdrojeFinancovania'?: Array<ProjektFinancovanieInyZdroj>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjektFinancovanie
     */
    'sposobFinancovania'?: Array<ProjektFinancovanieSposobFinancovaniaEnum>;
    /**
     * 
     * @type {ProjektFinancovanieStatnaPomoc}
     * @memberof ProjektFinancovanie
     */
    'statnaPomoc'?: ProjektFinancovanieStatnaPomoc;
}

export const ProjektFinancovanieSposobFinancovaniaEnum = {
    SystemPredfinancovania: 'SYSTEM_PREDFINANCOVANIA',
    SystemZalohovyvhPlatieb: 'SYSTEM_ZALOHOVYVH_PLATIEB',
    SystemRefundacie: 'SYSTEM_REFUNDACIE',
    KombinovanySystem: 'KOMBINOVANY_SYSTEM'
} as const;

export type ProjektFinancovanieSposobFinancovaniaEnum = typeof ProjektFinancovanieSposobFinancovaniaEnum[keyof typeof ProjektFinancovanieSposobFinancovaniaEnum];


